// extracted by mini-css-extract-plugin
export default {"dots":"Dots_dots__eOvcM","unassigned":"Dots_unassigned__esHn1","red":"Dots_red__MUU+e","yellow":"Dots_yellow__A6-ym","green":"Dots_green__V8Pf3","active":"Dots_active__UTmet"};